// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".theme--light.v-counter{color:rgba(0,0,0,.6)}.theme--dark.v-counter{color:rgba(255,255,255,.7)}", ""]);
// Exports
module.exports = exports;
